define.alias("ember-style-modifier/modifiers/style", "calendar/modifiers/style");